import { useAuth } from '@/contexts/auth-context';
import { dashboardPathForRole } from '@/contexts/role-home';

/** Whether the visitor is signed in, and where their dashboard is (same rule as the old home page). */
export function useHomeAuth(): { isAuthenticated: boolean; dashboardPath: string } {
  const { isAuthenticated, user } = useAuth();
  const dashboardPath = dashboardPathForRole(user?.role);
  return { isAuthenticated, dashboardPath };
}
